import styled from "styled-components";
import { zIndex } from "theme/variables";

const VERIZON_RED = "#EE0000";

export const StyledWrapper = styled.div`
  position: relative;
  border-radius: 1.25rem;
`;

export const StyledTile = styled.button`
  z-index: ${zIndex.notBottom};
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  min-width: 225px;
  height: 14rem;

  padding: 1.25rem;
  box-sizing: border-box;

  border: ${VERIZON_RED} 2px solid;
  border-radius: 1.125rem;
  overflow: hidden;

  background-color: #ffffff;
  color: ${VERIZON_RED};

  > a {
    text-decoration: none;
    color: inherit;

    width: 100%;
    height: 100%;
    flex: 1 1 auto;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  svg {
    align-self: flex-end;
    flex: 0 0 auto;
  }

  /* The VDS right-arrow is a filled path ~1.145 units thick in a 21.6
     viewBox; an equal-width stroke in the same color doubles its weight.
     Fill and stroke both track currentColor so the tile's own color alone
     drives the swap on hover — the VDS color prop paints fill as a
     presentation attribute, which CSS outranks. */
  svg path {
    fill: currentColor;
    stroke: currentColor;
    stroke-width: 1.145;
    stroke-linejoin: round;
    stroke-linecap: round;
  }

  /* Same reason for color: inherit — VDS Title sets its own color from a
     prop, and this outranks it so the headings follow the tile. */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: inherit;
    text-align: left;
    margin: 0;
    font-size: 2rem;
    line-height: 1.05;
  }

  &:not(.expanded):hover {
    cursor: pointer;
    background-color: ${VERIZON_RED};
    color: #ffffff;
  }

  /* Collapsing to the sliver keeps the border in the box model
     (transparent, not removed) so the contents don't shift, and the padding
     eases out in step with the height instead of snapping to 0. Only the
     top edge stays visible, as a rule above the open form — squared off,
     since a 1.25rem radius on a 4px-tall box would bend it. */
  &.expanded {
    position: absolute;
    height: 0.25rem;
    padding: 0;
    border-color: transparent;
    border-top-color: ${VERIZON_RED};
    border-radius: 0;
    background-color: transparent;

    > * {
      opacity: 0;
    }
  }

  > * {
    opacity: 1;
    transition: opacity 0.25s;
  }

  transition: color 0.25s, background-color 0.25s, height 0.25s, padding 0.25s,
    border-color 0.25s, border-radius 0.25s;
`;
